import type { RunToDatabase } from '@/types'
import { CorruptedDatabaseFileException } from '@pkg/basic'
import { sql } from 'drizzle-orm'
import { migrate0000 } from './0000'
import { migrate0001 } from './0001'
import { migrate0002 } from './0002'
import { migrate0003 } from './0003'

const migrates = [migrate0000, migrate0001, migrate0002, migrate0003]

export const migration = async (params: {
  isInitialMigration?: boolean
  readFromDatabase: RunToDatabase
  writeToDatabase: RunToDatabase
}) => {
  const {
    isInitialMigration = false,
    readFromDatabase,
    writeToDatabase,
  } = params
  const TABLE_NAME = '__migrations'
  const tableRows = await readFromDatabase((database) =>
    (async () => {
      return await database.database.values(
        sql`SELECT \`name\` FROM \`sqlite_master\` WHERE \`type\` = 'table' AND \`name\` = '${TABLE_NAME}';`,
      )
    })(),
  )
  if (tableRows.length === 0) {
    if (!isInitialMigration) {
      throw new CorruptedDatabaseFileException()
    }
    await writeToDatabase((database) =>
      (async () => {
        return await database.database.run(sql`CREATE TABLE \`${TABLE_NAME}\` (
      \`id\` INTEGER PRIMARY KEY NOT NULL
    );`)
      })(),
    )
  }
  const data = await readFromDatabase((database) =>
    (async () => {
      return await database.database.values<[number]>(
        sql`SELECT \`id\` FROM \`${TABLE_NAME}\` ORDER BY \`id\` DESC LIMIT 1;`,
      )
    })(),
  )
  const lastMigrationId = data.length > 0 ? data[0][0] : -1
  for (const [index, migrate] of migrates.entries()) {
    if (index <= lastMigrationId) {
      continue
    }
    await writeToDatabase((database) =>
      (async () => {
        await database.database.run(migrate)
      })(),
    )
    await writeToDatabase((database) =>
      (async () => {
        await database.database.run(
          sql`INSERT INTO \`${TABLE_NAME}\` (\`id\`) VALUES (${sql.raw(`${index}`)});`,
        )
      })(),
    )
  }
}
